export default "__VITE_ASSET__CflnD1B6__"